import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
	chip: {
		display: undefined,
		backgroundColor: '#E3E3E3',
		padding: '2 4',
		borderRadius: 4,
		fontSize: 8,
	},
	chipSuccess: {
		backgroundColor: '#E9F9E8',
	},
});

interface PdfChipProps {
	label: string,
	isSuccess?: boolean,
}

const PdfChip = (props: PdfChipProps) => {
	const {
		label,
		isSuccess = false,
	} = props;

	return (
		<Text style={[
			styles.chip,
			isSuccess ? styles.chipSuccess : {},
		]}
		>
			{label}
		</Text>
	);
};

export default PdfChip;
